import { BehaviorSubject, Observable } from 'rxjs';

export class StoreItem<T> {
  constructor(public item: T) {
    this.value = item;
    this.subject = new BehaviorSubject<T>(this.value);
    this.observable = this.subject.asObservable();
  }

  private value: T;
  private subject: BehaviorSubject<T>;
  private observable: Observable<T>;

  public setValue(value: T) {
    this.value = JSON.parse(JSON.stringify(value)) as T;
    this.subject.next(value);
  }

  public getValue(): T {
    return this.value;
  }

  public getObservable(): Observable<T> {
    return this.observable;
  }
}
